import {History, LocationState} from 'history'
import {NavigatorForAdminPage} from './NavigatorForAdminPage'
import {AdminAgreementDetail} from '../Models/Agreement/DTO/AdminAgreementDetailDTO'
import {AgreementRevisePageState, SystemAgreementRevisePageState} from '../Views/Pages/Agreements/AgreementRevisePage'
import {AgreementListPageState} from '../Views/Pages/Agreements/AgreementsListPage'
import {MemberSearchPageState} from "../Views/Pages/Members/MemberSearchPage";

export class NavigatorForAdminPageImpl implements NavigatorForAdminPage {

  private browserHistory: History

  constructor(browserHistory: History<LocationState>) {
    this.browserHistory = browserHistory
  }

  goToModeSelectionPage(): void {
    this.browserHistory.push('/admins/select_mode')
  }

  goToAdministratorsRegisterPage(): void {
    this.browserHistory.push('/admins/managers/create')
  }

  goToAdministratorsListPage(snackbarMessage?: string, highlightId?: number): void {
    this.browserHistory.push({
      pathname: '/admins/managers',
      state: {
        snackbarMessage: snackbarMessage,
        highlightId: highlightId,
      },
    })
  }

  goToAdministratorsEditPage(administratorId: number): void {
    this.browserHistory.push(`/admins/managers/${administratorId}`)
  }

  goToAdministratorsActivateCompletePage(): void {
    this.browserHistory.push('/admins/managers/activate/complete')
  }

  goToAdministratorsPasswordResetRequestedPage(): void {
    this.browserHistory.push('/admins/managers/password/reset/requested')
  }

  goToAdministratorsPasswordResetCompletePage(): void {
    this.browserHistory.push('/admins/managers/password/reset/complete')
  }

  goToFanClubManagementTopPage(bucketKey: string): void {
    this.browserHistory.push(`/admins/${bucketKey}/top`)
  }

  goToAnnouncementsRegisterPage(bucketKey: string): void {
    this.browserHistory.push(`/admins/${bucketKey}/announcements/create`)
  }

  goToAnnouncementsListPage(
    bucketKey: string,
    registeredAnnouncementId?: number,
    updatedAnnouncementId?: number,
  ): void {
    this.browserHistory.push({
      pathname: `/admins/${bucketKey}/announcements`,
      state: {
        registeredAnnouncementId: registeredAnnouncementId,
        updatedAnnouncementId: updatedAnnouncementId,
      },
    })
  }

  goToAnnouncementsEditPage(bucketKey: string, announcementId: number): void {
    this.browserHistory.push(`/admins/${bucketKey}/announcements/${announcementId}/edit`)
  }

  goToMovieContentsRegisterPage(bucketKey: string): void {
    this.browserHistory.push(`/admins/${bucketKey}/movies/create`)
  }

  goToMovieContentsListPage(
    bucketKey: string,
    registeredMovieContentId?: number,
    updatedMovieContentId?: number,
  ): void {
    this.browserHistory.push({
      pathname: `/admins/${bucketKey}/movies`,
      state: {
        registeredMovieContentId: registeredMovieContentId,
        updatedMovieContentId: updatedMovieContentId,
      },
    })
  }

  goToMovieContentsEditPage(bucketKey: string, movieContentId: number): void {
    this.browserHistory.push(`/admins/${bucketKey}/movies/${movieContentId}/edit`)
  }

  goToPhotoContentsRegisterPage(bucketKey: string): void {
    this.browserHistory.push(`/admins/${bucketKey}/photos/create`)
  }

  goToPhotoContentsListPage(
    bucketKey: string,
    registeredPhotoContentId?: number,
    updatedPhotoContentId?: number,
  ): void {
    this.browserHistory.push({
      pathname: `/admins/${bucketKey}/photos`,
      state: {
        registeredPhotoContentId: registeredPhotoContentId,
        updatedPhotoContentId: updatedPhotoContentId,
      },
    })
  }

  goToPhotoContentsEditPage(bucketKey: string, photoContentId: number): void {
    this.browserHistory.push(`/admins/${bucketKey}/photos/${photoContentId}/edit`)
  }

  goToSearchMembersPage(bucketKey: string, snackbarMessage?: string): void {
    const status: MemberSearchPageState = {snackbarMessage}
    this.browserHistory.push(`/admins/${bucketKey}/members_search`, status)
  }

  goToMemberDetailInfoPage(bucketKey: string, memberId: number): void {
    this.browserHistory.push(`/admins/${bucketKey}/members_search/${memberId}`)
  }


  goToMemberContractHistoryPage(bucketKey: string, memberId: number): void {
    this.browserHistory.push(`/admins/${bucketKey}/members_search/${memberId}/contract_history`)
  }

  goToMemberDenyAttributeHistoryPage(
    bucketKey: string,
    memberId: number,
    registeredId?: number,
  ): void {
    this.browserHistory.push({
      pathname: `/admins/${bucketKey}/members_search/${memberId}/deny_attribute_history`,
      state: {registeredId},
    })
  }

  goToMemberDenyAttributeEditPage(bucketKey: string, memberId: number): void {
    this.browserHistory.push(`/admins/${bucketKey}/members_search/${memberId}/deny_attribute/edit`)
  }

  goToBucketSettingPage(bucketKey: string): void {
    this.browserHistory.push(`/admins/${bucketKey}/setting`)
  }

  goToSystemAgreementDetailPage(agreementId: number): void {
    this.browserHistory.push(`/admins/agreements/${agreementId}`)
  }

  goToAgreementDetailPage(bucketKey: string, agreementId: number): void {
    this.browserHistory.push(`/admins/${bucketKey}/setting/agreements/${agreementId}`)
  }

  goToActiveAgreementPage(bucketKey: string): void {
    this.browserHistory.push(`/admins/${bucketKey}/setting/agreements/active`)
  }

  goToSystemAgreementListPage(snackbarMessage?: string, highlightId?: number): void {
    const state: AgreementListPageState = {snackbarMessage, highlightId}
    this.browserHistory.push('/admins/agreements', state)
  }

  goToAgreementListPage(bucketKey: string, snackbarMessage?: string, highlightId?: number): void {
    const state: AgreementListPageState = {snackbarMessage, highlightId}
    this.browserHistory.push(`/admins/${bucketKey}/setting/agreements`, state)
  }

  goToSystemAgreementRevisePage(agreement: AdminAgreementDetail): void {
    const state: SystemAgreementRevisePageState = {agreement}
    this.browserHistory.push(`/admins/agreements/${agreement.id}/revise`, state)
  }

  goToAgreementRevisePage(bucketKey: string, agreement: AdminAgreementDetail): void {
    const state: AgreementRevisePageState = {
      agreement, pathnameFrom: this.browserHistory.location.pathname,
    }
    this.browserHistory.push(`/admins/${bucketKey}/setting/agreements/revise`, state)
  }

  goToDownloadPage(downloadUrl: string): void {
    location.href = downloadUrl
  }

  goToLogoutPage(): void {
    this.browserHistory.push('/admins/logout')
  }

  gotoUrl(path: string): void {
    this.browserHistory.push({pathname: path})
  }

  clearState(): void {
    this.browserHistory.replace({state: {}})
  }

  gotoSignboardListPage(snackbarMessage?: string, highlightId?: number): void {
    this.browserHistory.push({
      pathname: '/admins/signboards',
      state: {
        snackbarMessage: snackbarMessage,
        highlightId: highlightId,
      },
    })
  }

  gotoSignboardRegisterPage(): void {
    this.browserHistory.push(`/admins/signboards/register`)
  }

  gotoSignboardDuplicatePage(signboardId: number): void {
    this.browserHistory.push(`/admins/signboards/register?ref=${signboardId}`)
  }

  gotoSignboardDetailPage(signboardId: number): void {
    this.browserHistory.push(`/admins/signboards/${signboardId}`)
  }

}
